import DiscoveryBanner from '../DiscoveryBanner';
import FeatureTilesContainer from '../FeatureTilesContainer';
import { StyledContainer } from './styled';

const DiscoveryHeader = () => (
  <StyledContainer>
    <DiscoveryBanner />
    <FeatureTilesContainer />
  </StyledContainer>
);

export default DiscoveryHeader;
